<template>
  <div> 
    <NotificationList v-if="isLoggedUser" :notificationDrawer='NotificationDrawer'/>
    <TopMenu2 v-if="isLoggedUser"  :topMenuDrawer='drawer' />
    <v-content >
     
    <router-view>
   
    </router-view>

   </v-content>
    
    <ProcessLog :bottomSheet="bottomSheet"/>
    <v-footer v-if="isLoggedUser" color="primary" app inset>
        <v-layout row wrap>
          <v-flex xs1 sm1 md1>
        <span class="white--text ">&copy;2017</span>
        </v-flex>
          <v-flex xs8 sm8 md8>
            &nbsp;
            </v-flex>
        <v-flex xs2 sm2 md2> 
        <DigitalClock/>
        
        </v-flex>
        
        </v-layout>
        
       </v-footer>
    </div>  
</template>
<script>
import NotificationList from './NotificationList.vue'
import SideMenu from './SideMenu.vue'
import TopMenu2 from './TopMenu2'
import BreadCrumps from './BreadCrumps'
import DigitalClock from './DigitalClock'
import ProcessLog from './ProcessLog'

export default {
  

  components: {
    TopMenu2,
    SideMenu,
    BreadCrumps,
    DigitalClock,
    NotificationList,
    ProcessLog,
    
  },
  data:()=>({

   drawer :false,
   isLoggedUser: false,
   NotificationDrawer:false,
   bottomSheet:false,

  }),
  created() {
     this.$on('drawerClicked', $drawer => {
        this.drawer = !this.drawer
        this.bottomSheet = false
        this.NotificationDrawer=false
      });

    this.$on('processClicked', $drawer => {
          this.bottomSheet = !this.bottomSheet
      

      });

    this.$on('NotificationListClicked', $drawer => {
        this.bottomSheet = false
        this.drawer=false

        if(this.NotificationDrawer ) { 
          this.NotificationDrawer=false
        }
        this.NotificationDrawer = !this.NotificationDrawer
      });

    this.$on('NotificationTransitionEnd',$drawer => {
   //   this.NotificationDrawer = false
    })
  },
 mounted: function() {
   this.isLoggedUser =   localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)
  
  },
  updated: function() {
   this.isLoggedUser =   localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)

  },
  methods: {
   
    checkEvent()
    {
      var $a;
      $a=0;
    },
    showBottomSheet() {
      this.bottomSheet = true
    },
    
      TriggerDrawEvent($drawer) {
          this.drawer=$drawer
      }
  }
  }
</script>

<style>

</style>
